<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title style="justify-content: center">
            Panou Administrare
          </v-card-title>

          <v-card-text>
            <v-tabs
              v-model="tab"
              background-color="transparent"
              color="basil"
              grow>
              <v-tab>
                Utilizatori
              </v-tab>
              <v-tab>
                FAQ
              </v-tab>
              <v-tab>
                Resurse
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <Users />
              </v-tab-item>
              <v-tab-item>
                <FAQ />
              </v-tab-item>
              <v-tab-item>
                <Resources />
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Users from '@/components/Users.vue'
import FAQ from '@/components/FAQ.vue'
import Resources from '@/components/Resources.vue'
// import Options from '@/components/Options.vue'

export default {
  name: 'AccountAdminComponent',

  components: { Users, FAQ, Resources },

  data: () => ({
    tab: null
  })
}
</script>
